"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationForm = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* Package Imports */
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var Yup = __importStar(require("yup"));
/* Imported CSS */
require("./RegistrationForm.scss");
/* Blast Imports */
var YellowButton_1 = require("@app/components/controls/YellowButton");
var passwordValidator_1 = require("@app/services/passwordValidator");
var validationSchema = Yup.object().shape({
    firstName: Yup.string().trim().required('Please enter your first name'),
    lastName: Yup.string().trim().required('Please enter your last name'),
    company: Yup.string().trim().required('Please enter your company'),
    password: Yup.string()
        .trim()
        .required('Please enter a password')
        .test('strength', 'Password does not meet complexity requirements', function (value) { return passwordValidator_1.isStrong(value); }),
    passwordConfirmed: Yup.string()
        .trim()
        .required('Please confirm your password')
        .oneOf([Yup.ref('password')], 'Passwords do not match'),
    title: Yup.string(),
    location: Yup.string()
});
/**
 * Blast's User Registration Form component, displays the form to register a user
 */
var RegistrationForm = /** @class */ (function (_super) {
    __extends(RegistrationForm, _super);
    function RegistrationForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegistrationForm.prototype.render = function () {
        var _a = this.props, touched = _a.touched, errors = _a.errors;
        return (react_1.default.createElement(formik_1.Form, { className: "registration-form" },
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "First Name"),
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement(formik_1.Field, { name: "firstName", className: "input", autoFocus: true }),
                            touched.firstName && errors.firstName &&
                                react_1.default.createElement("p", { className: "help is-danger" }, errors.firstName)))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "Last Name"),
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement(formik_1.Field, { name: "lastName", className: "input" }),
                            touched.lastName && errors.lastName &&
                                react_1.default.createElement("p", { className: "help is-danger" }, errors.lastName))))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement("label", { className: "label" }, "Company"),
                    react_1.default.createElement(formik_1.Field, { name: "company", className: "input" }),
                    touched.company && errors.company &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.company))),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "Password"),
                        react_1.default.createElement(formik_1.Field, { name: "password", type: "password", className: "input" }),
                        touched.password && errors.password &&
                            react_1.default.createElement("p", { className: "is-danger help", "data-test": "password-error" }, errors.password))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "Confirm Password"),
                        react_1.default.createElement(formik_1.Field, { name: "passwordConfirmed", type: "password", className: "input" }),
                        touched.passwordConfirmed && errors.passwordConfirmed &&
                            react_1.default.createElement("p", { className: "is-danger help", "data-test": "confirm-password-error" }, errors.passwordConfirmed)))),
            react_1.default.createElement("h1", { className: "is-6 has-text-centered" },
                "Your password MUST be 9 characters long and MUST contain:",
                react_1.default.createElement("ul", null,
                    react_1.default.createElement("li", null, "Uppercase character"),
                    react_1.default.createElement("li", null, "Lowercase character"),
                    react_1.default.createElement("li", null, "Number"),
                    react_1.default.createElement("li", null, "Symbol, including @ $ ! % * ? or &"))),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement("label", { className: "label" },
                                "Title ",
                                react_1.default.createElement("span", { className: "help is-inline" }, "(optional)")),
                            react_1.default.createElement(formik_1.Field, { name: "title", className: "input" })))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement("label", { className: "label" },
                                "Location ",
                                react_1.default.createElement("span", { className: "help is-inline" }, "(optional)")),
                            react_1.default.createElement(formik_1.Field, { name: "location", className: "input" }))))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(YellowButton_1.YellowButton, { type: "submit", className: "button-large", isFullWidth: true },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-clipboard" })),
                        react_1.default.createElement("span", null, "Finish Registration"))))));
    };
    return RegistrationForm;
}(react_1.Component));
exports.RegistrationForm = RegistrationForm;
exports.default = formik_1.withFormik({
    validationSchema: validationSchema,
    mapPropsToValues: function (props) {
        return {
            company: '',
            firstName: '',
            lastName: '',
            location: '',
            password: '',
            passwordConfirmed: '',
            title: ''
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onRegister(bag.props.email, bag.props.context, values.firstName.trim(), values.lastName.trim(), values.company.trim(), values.password, values.passwordConfirmed, values.title ? values.title.trim() : undefined, values.location ? values.location.trim() : undefined);
    }
})(RegistrationForm);
